/* NordicSmile · lekka karuzela mobilna (scroll-snap + przyciski + klawiatura). Bez bibliotek, bez autoplay. */
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-ns-carousel]').forEach(function (c) {
      if (c.dataset.nsInit) return;
      c.dataset.nsInit = '1';
      var track = c.querySelector('[data-ns-track]');
      var prev = c.querySelector('[data-ns-prev]');
      var next = c.querySelector('[data-ns-next]');
      if (!track || !prev || !next) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function step() {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
      }
      function go(dir) {
        track.scrollBy({ left: dir * step(), behavior: reduced ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
